import Cookies from "js-cookie";
import { Configuration } from "api-client";

export function getApiConfiguration(serverBaseUrl, teamId) {
  return new Configuration({
    basePath: serverBaseUrl,
    headers: getApiHeaders(teamId),
  });
}

export function getApiHeaders(teamId) {
  return {
    "X-CSRFToken": Cookies.get("csrftoken"),
    ...(teamId != null ? { "X-Team-ID": String(teamId) } : {}),
  };
}
